export const apiDomain = 'https://us-central1-incentable-app-37d9c.cloudfunctions.net/webApi/api/v1'

